<template>
  <v-dialog v-model="show" fullscreen transition="dialog-bottom-transition">
    <v-card color="grey lighten-3">
      <v-toolbar>
        <v-btn icon @click="$emit('closeNewDocumentDialog')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title v-show="selectedState === 'document'">
          Novo Documento
        </v-toolbar-title>
        <v-toolbar-title v-show="selectedState === 'minute'">
          Nova Minuta
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="custom-card-text">
        <v-layout justify-center align-center>
          <v-card min-height="400" width="500">
            <v-toolbar dark color="blue">
              <v-icon>mdi-file-plus</v-icon>Opções de documento
            </v-toolbar>
            <v-card-text>
              <span class="font-weight-bold">Selecione um tipo de documento</span>
              <v-autocomplete
                v-model="documentType"
                placeholder="Tipo de documento"
                :items="documentTypes"
                item-text="name"
                item-value="id"
                :loading="loading"
                :menu-props="{maxWidth: 480}"
                :hide-no-data="searchIsInvalid"
                no-data-text="Tipo de documento não encontrado"
                :search-input.sync="search"
              />
              <v-layout class="mt-4 mb-3" justify-center>
                <v-flex xs6 style="cursor: pointer">
                  <v-layout
                    style="position: relative"
                    column
                    align-center
                    @click="selectModel('blank')"
                    :class="{'document-type-selected': documentModel !== 'blank' && documentModel !== ''}"
                  >
                    <img class="mb-3" src="/static/images/document/papers.svg" width="90">
                    <v-layout
                      class="check"
                      v-if="documentModel === 'blank'"
                      align-center
                      justify-center
                    >
                      <v-icon size="18" class="font-weight-bold" color="green darken-2">mdi-check</v-icon>
                    </v-layout>
                    <span class="font-weight-bold">Em Branco</span>
                  </v-layout>
                </v-flex>

                <v-flex xs6 style="cursor: pointer">
                  <v-layout
                    style="position: relative"
                    column
                    align-center
                    @click="selectModel('default')"
                    :class="{'document-type-selected': documentModel !== 'default' && documentModel !== ''}"
                  >
                    <img class="mb-3" src="/static/images/document/visualization.svg" width="90">
                    <v-layout
                      class="check"
                      v-if="documentModel === 'default'"
                      align-center
                      justify-center
                    >
                      <v-icon size="18" class="font-weight-bold" color="green darken-2">mdi-check</v-icon>
                    </v-layout>
                    <span class="font-weight-bold">Modelo Pré-definido</span>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn flat @click="cancel">Cancelar</v-btn>
              <v-spacer/>
              <v-btn
                class="white--text"
                color="blue"
                @click="createDocument"
                :disabled="!valid || creating"
              >Continuar</v-btn>
              <v-spacer/>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import documentsService from '@/services/DocumentsService';
import {isEmpty} from 'lodash';

export default {
  name: 'NewDocumentAndMinuteDialog',
  props: {
    id: {
      type: String,
      default: '',
    },
    show: {
      typ: Boolean,
      default: false,
    },
    selectedState: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      documentModel: '',
      documentType: '',
      documentTypeDetails: {},
      documentTypes: [],
      isEmpty,
      loading: false,
      creating: false,
      timeout: null,
      search: '',
      selectDocumentTypeDialog: false,
    };
  },
  methods: {
    cancel() {
      this.documentModel = '';
      this.documentType = '';
      this.documentTypeDetails = {};
    },
    getDocumentTypes(query) {
      clearTimeout(this.timeout);
      this.loading = true;
      this.timeout = setTimeout(() => {
        documentsService.getDocumentTypes(query)
          .then(({ data }) => {
            this.documentTypes = data;
          })
          .catch((err) => {
            this.onRequestError(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }, 700);
    },
    // getDocumentTypeDetails() {
    //   documentsService.getDocumentType(this.documentType)
    //     .then(({ data }) => {
    //       this.documentTypeDetails = data;
    //     })
    //     .catch((err) => {
    //       this.onRequestError(err);
    //     });
    // },
    selectModel(model) {
      this.documentModel = model;
    },
    createDocument() {
      if (this.creating) return;

      this.creating = true;
      let documentState = '';
      if (this.selectedState === 'minute') {
        documentState = 'minute_draft';
      } else if (this.selectedState === 'document') {
        documentState = 'draft';
      }
      documentsService.createNewDocument(this.folder.id, this.documentType, documentState)
        .then(({ data }) => {
          this.onRequestSuccess('Documento criado com sucesso!', data.document_id);
        })
        .catch((err) => {
          this.onRequestError(err);
        })
          .finally(() => {
            this.creating = false;
          });
    },
    onRequestSuccess(message, documentId) {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'success',
        message,
        button: {show: true, text: 'Fechar', message: ''},
        timeout: 6000,
      });
      this.$emit('documentCreated', {documentId, documentModel: this.documentModel});
    },
    onRequestError(err) {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'error',
        message: err.response.data,
        messageIcon: 'mdi-alert-outline',
      });
    },
  },
  computed: {
    folder() {
      return this.$store.getters.activeFolder;
    },
    valid() {
      return !isEmpty(this.folder) &&
          this.documentType !== '' &&
          this.documentModel !== '';
    },
    searchIsInvalid() {
      return isEmpty(this.search) || this.search !== undefined || this.search.length < 3;
    },
  },
  watch: {
    search(val) {
      if (val !== null && val !== undefined && val.length > 2) {
        this.getDocumentTypes(val);
      }
    },
  },
};
</script>

<style>
.document-checkbox {
  margin-top: -13px;
  margin-right: 0;
}

.document-type-selected {
  opacity: 0.5;
  color: rgba(0 0 0 0.54);
}

.check {
  position: absolute;
  border-radius: 50%;
  background: white;
  width: 20px;
  height: 20px;
  padding: 13px;
  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
  bottom: 25px;
}

.custom-card-text {
  display: flex;
  height: calc(100vh - 48px);
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/document/new/NewDocumentAndMinuteDialog.vue